export interface CurrencyDetails {
    currencyCode: string;
    currencyNumericCode: number;
    displayName: string;
    symbol: string;
}

export interface ExchangeRateResult {
    from: string;
    rate: number;
    rateTimestamp: Date;
    to: string;
}

export interface SiteCoreDictionary {
    [value: string]: string;
}

interface PiwikTag {
    dataTrackId: string;
    dataTrackLinkname: string;
}

interface PiwikTags {
    [value: string]: PiwikTag;
}

export interface Piwik {
    [value: string]: PiwikTags;
}

export interface VisaFxSimpleCalculatorProps {
    availableCurrencies: CurrencyDetails[];
    calculator: Calculator;
    loadingRate: boolean;
    onChangeAmountFrom: (amount: number | undefined) => void;
    onChangeAmountTo: (amount: number | undefined) => void;
    onChangeCurrency: (currency: CurrencyDetails | undefined, field: CalculatorFieldName) => void;
    onClickMoreInfo: () => void;
    onClickSelectCurrency: (field: CalculatorFieldName) => void;
    rateError: string | undefined;
    setFocusedField: (calculatorFieldName: CalculatorFieldName | undefined) => void;
    swapCurrencies: () => void;
    currencyOnRightSide: boolean;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

export enum CommonCurrency {
    NOK = 'NOK',
    SEK = 'SEK',
    DKK = 'DKK',
    EUR = 'EUR',
    USD = 'USD',
}

export enum CalculatorFieldName {
    FROM = 'FROM',
    TO = 'TO',
}

export interface CalculatorField {
    amount: number | undefined;
    currency: CurrencyDetails;
}

export interface ExchangeRate {
    from: ExchangeRateResult | undefined;
    to: ExchangeRateResult | undefined;
}

export interface Calculator {
    from: CalculatorField;
    to: CalculatorField;
    exchangeRate: ExchangeRate;
    rateAt: Date | undefined;
}

export interface FetchError {
    errorName: string;
    status?: number | null;
    code?: string | null;
    type?: string | null;
    message?: string | null;
    link?: string | null;
    name?: string | null;
    developerMessage?: string | null;
    requestCorrelationId?: {
        value: string | null;
    };
}
